// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3Evu8","savePackageButton":"ClientWallet_savePackageButton__1VW4c"};